/// <amd-module name="TFS/DRITools/Components/Common/Loading" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import * as Resources from "TFS/DRITools/Resources";

export interface ILoadingProps {}

export class Loading extends VssComponent<ILoadingProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="dri-tools-common loading-container">
                <Spinner size={SpinnerSize.large} label={Resources.Common_LoadingLabel} />
            </div>
        );
    }
}

export default Loading;
